import { v4 as uuidv4 } from "uuid";
import { CustomerSubscriptionItem } from "../CustomerSubscription.item";
import { CustomerTokenItem } from "../CustomerToken.item";
import { EGiftTransaction } from "../eGift/EGiftTransaction.model";
import { Store } from "../store";
import { CustomerAddress } from "./CustomerAddress.entity";
import { CustomerPhone } from "./CustomerPhone.entity";
import { CustomerToken } from "./CustomerToken.entity";
import { CustomerVenue } from "./CustomerVenue.entity";

export class Customer {
	key: string = uuidv4();
	firstName: string;
	lastName: string;
	email: string;
	firstVisitVenueKey: number;
	lastVisitVenueKey: number;
	firstVisitDateTime: Date = new Date();
	lastVisitDateTime: Date = new Date();
	visitCount: number;
	visitRevenue: number;
	passwordHash: string;
	salt: string;
	created: Date = new Date();
	modified: Date = new Date();
	deleted: boolean;

	FirstVisitVenue: Store;

	LastVisitVenue: Store;

	CustomerVenue: CustomerVenue[];

	CustomerPhone: CustomerPhone[];

	CustomerToken: CustomerToken[];

	CustomerAddress: CustomerAddress[];

	customerKey: string;
	venuesVisited: number[];
	loginEvent: any[];

	valdiationCode: string;
	validationCodeExpireTime: string;

	addresses: CustomerAddress[];
	phonesNumbers: CustomerPhone[];
	tokens: CustomerTokenItem[];
	venues: CustomerVenue[];
	subscriptions: CustomerSubscriptionItem[];

	giftCardsReceived: EGiftTransaction[];
	giftCardsPurchased: EGiftTransaction[];

	public constructor(init?: Partial<Customer>) {
		Object.assign(this, init);
	}
}
